import React from 'react';
import { Icon, Tooltip, Whisper, Button } from 'rsuite';
import styles from './BigNumbersArea.module.scss';
import { BigNumbersType } from '../../types';
import { LoadingSpinerLocal } from '../../../../../../components';

type BigNumbersAreaProps = {
  data?: BigNumbersType;
  isLoading?: boolean;
  onClickDownload?: () => void;
};

export const BigNumbersArea = ({ data, isLoading, onClickDownload }: BigNumbersAreaProps) => {
  const productsNotFound = !!data && data.produtosEncontrados !== data.produtosInteresse;
  return (
    <div className={styles.container}>
      <LoadingSpinerLocal loading={isLoading} size="md" />
      <div className={styles.box}>
        <p className={styles.numbers}>{data?.produtosEncontrados ?? 0}</p>
        <p className={styles.title}>Produtos encontrados</p>
        <div className={styles['subtitle-wrapper']}>
          <span className={styles.subtitle}>de um total de {data?.produtosInteresse ?? 0} produtos de interesse</span>
          <Whisper
            trigger="hover"
            speaker={<Tooltip>Você pode configurar estes produtos no Modo Administrador, localizado no menu superior à direita da tela.</Tooltip>}
          >
            <Icon className={styles.icon} icon="info" />
          </Whisper>
        </div>
        {productsNotFound ? (
          <Button className={styles['download-button']} size="xs" appearance="link" onClick={onClickDownload}>
            Fazer download de produtos não encontrados
          </Button>
        ) : null}
      </div>
      <div className={styles['middle-box']}>
        <p className={styles.numbers}>{data?.redesEncontradas ?? 0}</p>
        <p className={styles.title}>Redes encontradas</p>
      </div>
      <div className={styles.box}>
        <p className={styles.numbers}>{data?.lojasEncontradas ?? 0}</p>
        <p className={styles.title}>Lojas encontradas</p>
      </div>
    </div>
  );
};
